import React from 'react';
import VendorCard from './VendorCard';

const VendorGrid = ({ 
  vendors, 
  category, 
  onVendorClick, 
  showCompatibility = false,
  emptyMessage = "No vendors found",
  layoutMode = 'grid'
}) => {
  if (vendors.length === 0) {
    return (
      <div className="text-center py-16 bg-gradient-to-br from-rose-50 via-pink-50 to-champagne-50 rounded-2xl border border-rose-200 shadow-lg">
        <div className="text-6xl mb-6 animate-bounce">🔍</div>
        <p className="text-rose-600 text-xl font-semibold mb-2">{emptyMessage}</p>
        <p className="text-rose-400 text-sm">Try selecting a different category</p>
        <div className="mt-4 flex justify-center">
          <div className="w-16 h-1 bg-gradient-to-r from-rose-300 to-pink-300 rounded-full"></div>
        </div>
      </div>
    );
  }

  return (
    <div className={`${
      layoutMode === 'grid' 
        ? 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6' 
        : 'flex gap-6 overflow-x-auto pb-6 scroll-smooth'
    }`}>
      {vendors.map((vendor, index) => (
        <VendorCard
          key={vendor.id}
          vendor={vendor}
          index={index}
          category={category}
          onVendorClick={onVendorClick}
          showCompatibility={showCompatibility}
          layoutMode={layoutMode}
        />
      ))}
    </div>
  );
};

export default VendorGrid;
